(function () {
  'use strict';

  function smoothStep(start, end, value) {
    var amount = Math.max(0, Math.min(1, (value - start) / (end - start)));
    return amount * amount * (3 - 2 * amount);
  }

  function paperHalfThickness(x, y) {
    var distanceFromLongEdge = .36 - Math.abs(y);
    var edgeBlend = smoothStep(0, .055, distanceFromLongEdge);
    var distanceFromCenter = Math.abs(x);
    var endCompression = 1 - smoothStep(3.00, 3.55, distanceFromCenter);
    var crossSectionPosition = Math.min(1, Math.abs(y) / .36);
    var broadEnvelope = 1 - smoothStep(0, 1, Math.pow(crossSectionPosition, 3.08));
    var leftLobe = Math.exp(-.5 * Math.pow((y + .108) / .09, 2));
    var rightLobe = Math.exp(-.5 * Math.pow((y - .108) / .09, 2));
    var joinedLobes = Math.min(1, (leftLobe + rightLobe) / 1.058);
    var preSealPinch = Math.exp(-Math.pow((distanceFromCenter - 3.43) / .085, 2));
    var shapedThickness =
      .009 +
      (
        .070 * broadEnvelope +
        .0085 * joinedLobes
      ) *
      edgeBlend *
      endCompression;

    return Math.max(
      .009,
      shapedThickness -
        .0045 *
        Math.max(broadEnvelope, joinedLobes) *
        edgeBlend *
        preSealPinch
    );
  }

  function createPaperFace(THREE, group, material, back) {
    var geometry = new THREE.PlaneGeometry(7.6, .72, 48, 24);
    var positions = geometry.attributes.position;
    for (var vertex = 0; vertex < positions.count; vertex++) {
      positions.setZ(
        vertex,
        paperHalfThickness(positions.getX(vertex), positions.getY(vertex))
      );
    }
    positions.needsUpdate = true;
    geometry.computeVertexNormals();

    var face = new THREE.Mesh(geometry, material);
    if (back) face.rotation.y = Math.PI;
    face.castShadow = true;
    face.receiveShadow = true;
    group.add(face);
  }

  function create(THREE, frontTexture, backTexture) {
    var edgeMaterial = new THREE.MeshStandardMaterial({
      color: 0xf8f7f2,
      roughness: .96,
      metalness: 0
    });
    var frontMaterial = new THREE.MeshStandardMaterial({
      map: frontTexture,
      roughness: .96,
      metalness: 0
    });
    var backMaterial = new THREE.MeshStandardMaterial({
      map: backTexture,
      roughness: .96,
      metalness: 0
    });
    var crimpMaterial = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      roughness: 1,
      metalness: 0
    });
    var sleeve = new THREE.Group();

    createPaperFace(THREE, sleeve, frontMaterial, false);
    createPaperFace(THREE, sleeve, backMaterial, true);

    [-.354, .354].forEach(function (edgeY) {
      var longEdge = new THREE.Mesh(new THREE.BoxGeometry(7.586, .012, .018), edgeMaterial);
      longEdge.position.y = edgeY;
      longEdge.castShadow = true;
      sleeve.add(longEdge);
    });

    [-3.793, 3.793].forEach(function (edgeX) {
      var endEdge = new THREE.Mesh(new THREE.BoxGeometry(.014, .696, .018), edgeMaterial);
      endEdge.position.x = edgeX;
      endEdge.castShadow = true;
      sleeve.add(endEdge);
    });

    var crimpGeometry = new THREE.BoxGeometry(.018, .58, .014);
    var crimpRibs = new THREE.InstancedMesh(crimpGeometry, crimpMaterial, 16);
    var crimpTransform = new THREE.Object3D();
    var crimpInstance = 0;
    [-1, 1].forEach(function (side) {
      for (var crimp = 0; crimp < 4; crimp++) {
        var crimpX = side * (3.59 + crimp * .048);
        [1, -1].forEach(function (faceDirection) {
          crimpTransform.position.set(crimpX, 0, faceDirection * .013);
          crimpTransform.updateMatrix();
          crimpRibs.setMatrixAt(crimpInstance, crimpTransform.matrix);
          crimpInstance++;
        });
      }
    });
    crimpRibs.instanceMatrix.needsUpdate = true;
    sleeve.add(crimpRibs);

    return sleeve;
  }

  window.ERSChopstickSleeveGeometry = {
    create: create
  };
}());
